import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DefaultPicture from '../../../components/01_atoms/DefaultPicture';

import s from './index.module.scss';

const BasketBundleDetails = ({ bundle }) => {
  const products = useSelector((state) => state.productsStorage['gifts']);
  return (
    <div className={s['basket-bundle-details']}>
      <p className="space-top text-sm">With this bundle you get the following gifts:</p>
      <div className={s['basket-bundle-details__container']}>
        {bundle.giftsInBundle.map((id, index) => (
          <div className={`cart-item ${s['basket-bundle-details__item']}`} key={`${id}-${index}`}>
            <span className={s['basket-bundle-details__image']}>
              {products[id]?.image && <DefaultPicture {...products[id].image} />}
            </span>
            <div className={s['basket-bundle-details__details']}>{products[id].title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

BasketBundleDetails.propTypes = {
  bundle: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    title: PropTypes.string,
    categoryIds: PropTypes.arrayOf(PropTypes.string),
    variantType: PropTypes.string,
    annotation: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.object,
    image: PropTypes.object,
    actionImage: PropTypes.string,
    actionDescription: PropTypes.string,
    giftsInBundle: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default BasketBundleDetails;
